import { admissionTypesApi } from "@/api/endpoints";
import { CodeNameMasterPage } from "./CodeNameMasterPage";

/** Admission type master (General, Insurance, Corporate, Emergency…) — a service charge rate dimension. */
export function AdmissionTypesPage() {
  return (
    <CodeNameMasterPage
      title="Admission Types"
      noun="Admission type"
      subtitle="The basis a patient is admitted on. The same service can carry a different rate per admission type."
      api={admissionTypesApi}
      queryKey="admission-types"
      permPrefix="catalog.admissiontype"
    />
  );
}
